import * as types from "./mutation-types";

export default {
  [types.SET_IS_LOADING](state, payload) {
    state.isLoading = payload;
  },

  [types.SET_CONTENT_LIST](state, payload) {
    state.contentList = payload;
  },

  [types.CONTENT_LIST_ADD_ITEM](state, payload) {
    state.contentList.push(payload);
  },

  [types.CONTENT_LIST_UPDATE_ITEM](state, payload) {
    const index = state.contentList.findIndex(e => e.id === payload.id);
    state.contentList[index] = payload;

    state.contentList = state.contentList.slice();
  },

  [types.SET_TOTAL_ITEMS](state, total) {
    state.totalItems = total;
  }
};
